
























































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ChartOptionsMenu extends Vue {
    menu = false;

    changeChart (chart: string) {
        this.$emit('change-chart', chart)
    }
}
